import React, { useEffect, useState } from "react";
import Header from "../../componets/Header";
import { Link } from "react-router-dom";
import { FaCircleArrowLeft } from "react-icons/fa6";
import {
	Button,
	Col,
	Container,
	Table,
	Accordion,
	Row,
	Pagination,
	Form,
} from "react-bootstrap";
import AlertService from "../../helper/alertService";
import ApiService from "../../helper/api";
import MainService from "../../helper/mainService";
import { FaArrowCircleDown, FaArrowCircleUp } from "react-icons/fa";

function Component(props) {
	// const { merchantsWallets } = useLoaderData();
	const [walletInfo, setWaletInfo] = useState(null);
	const [walletsInfo, setWaletsInfo] = useState([]);
	const [merchantsWallets, setMerchantsWallets] = useState({});
	const [paginationData, setPaginationData] = useState({
		searchParameter: "",
		pageNumber: 1,
		pageSize: 10,
	});
	const [pagination, setPagination] = useState(null);

	useEffect(() => {
		getMerchantsWallets({
			searchParameter: "",
			pageNumber: 1,
			pageSize: 10,
		});
	}, []);

	const getMerchantsWallets = paginationData => {
		MainService.callApi({
			api: ApiService.merchantGetAll,
			data: paginationData,
			cb: response => {
				if (
					response.data &&
					response.data &&
					response.data.pagedData &&
					response.data.pagedData.length
				) {
					setMerchantsWallets(response.data.pagedData);
				}
				if (response?.data?.pagination) {
					setPagination(response?.data?.pagination);
				}
				setPaginationData(paginationData);
			},
		});
	};

	const getWolletInfo = (walletId, merchantId) => {
		if (!walletId) return false;
		MainService.callApi({
			api: ApiService.walletGetWalletBalance,
			data: walletId,
			cb: response => {
				if (response.data) {
					setMerchantsWallets(merchantsWallets =>
						merchantsWallets.map(el => {
							if (el.merchantId === merchantId) {
								return {
									...el,
									wallets: el.wallets.map(wallet =>
										wallet.id === walletId
											? {
													...wallet,
													walletInfo: { ...response.data, show: true },
											  }
											: wallet,
									),
								};
							}
							return el;
						}),
					);
				} else {
					AlertService.alert("error", "No Information");
					setWaletInfo(null);
					return null;
				}
			},
		});
	};

	const showInfo = (walletId, merchantId) => {
		setMerchantsWallets(merchantsWallets =>
			merchantsWallets.map(el => {
				if (el.merchantId === merchantId) {
					return {
						...el,
						wallets: el.wallets.map(wallet =>
							wallet.id === walletId
								? {
										...wallet,
										walletInfo: {
											...wallet.walletInfo,
											show: !wallet.walletInfo.show,
										},
								  }
								: wallet,
						),
					};
				}
				return el;
			}),
		);
	};

	const handlePageChange = pageNumber => {
		const newPaginationData = {
			...paginationData,
			pageNumber: pageNumber,
		};
		getMerchantsWallets(newPaginationData);
		// notificationGetAll(+pageNumber, isNew);
	};

	// const navaigate = useNavigate();

	const transactionReplenishingTheMerchantBalance = merchantId => {
		MainService.callApi({
			api: ApiService.transactionReplenishingTheMerchantBalance,
			data: merchantId,
			cb: response => {
				if (response.data && response.data.length) {
					showReplenishAlert(response.data);
				} else {
					AlertService.alert("error", "No wallet was replenished.");
				}
			},
		});
	};

	const showReplenishAlert = chains => {
		const success = chains.filter(item => item.status);
		const failed = chains.filter(item => !item.status);

		if (success.length) {
			success.forEach(item => {
				AlertService.alert(
					"success",
					`Successfully replenished: •${item.chainName}`,
				);
			});
		}

		if (failed.length) {
			failed.forEach(item => {
				AlertService.alert("error", `Failed to replenish: •${item.chainName}`);
			});
		}
	};

	return (
		<div>
			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0">Merchant wallets</h4>
					</div>
				</div>
			</Header>

			<Container style={{ paddingBlockEnd: "40px" }}>
				<div mt={4} className="d-flex justify-content-between w-100 mb-4">
					<Form
						onSubmit={event => {
							event.preventDefault();
							getMerchantsWallets({
								searchParameter: paginationData.searchParameter,
								pageNumber: 1,
								pageSize: 10,
							});
						}}
						style={{ width: "30rem" }}>
						<Form.Group
							controlId="search"
							className="d-flex gap-2 align-items-center">
							<Form.Control
								type="search"
								value={paginationData.searchParameter}
								size="sm"
								placeholder="Search..."
								onChange={event =>
									setPaginationData({
										...paginationData,
										searchParameter: event.target.value,
									})
								}
							/>
							<Button size="sm" variant="primary" type="submit">
								Search
							</Button>
						</Form.Group>
					</Form>
				</div>
				{merchantsWallets &&
					!!merchantsWallets.length &&
					merchantsWallets.map(item => (
						<Accordion
							key={item.merchantId}
							className="merchants_wallet_accordion">
							<Accordion.Item eventKey="0">
								<Accordion.Header>
									<div className="d-flex justify-content-between align-items-center w-100 me-3 gap-2 flex-wrap">
										{/* <b>Merchant ID: {item.merchantId}</b> */}
										<div className="d-flex align-items-center gap-3 flex-wrap">
											<b>Merchant ID: {item.merchantId}</b>

											<span className="text-muted">
												Name: {item.name || "Unknown"}
											</span>

											<span
												className={`badge ${
													item.isActive ? "bg-success" : "bg-danger"
												}`}>
												{item.isActive ? "Active" : "Inactive"}
											</span>
										</div>

										<Button
											size="sm"
											variant="outline-success"
											type="button"
											onClick={e => {
												e.stopPropagation();
												transactionReplenishingTheMerchantBalance(
													item.merchantId,
												);
											}}>
											Refresh Balance
										</Button>
									</div>
								</Accordion.Header>

								<Accordion.Body>
									<Table
										bordered
										hover
										responsive
										size="sm"
										className="align-middle">
										<thead className="table-light">
											<tr>
												<th>#</th>
												<th>Platform</th>
												<th>Wallet Address</th>
												<th className="text-center">Action</th>
											</tr>
										</thead>
										<tbody>
											{item.wallets?.map((wallet, index) => {
												return (
													<React.Fragment key={wallet.id}>
														<tr>
															<td>{index + 1}</td>
															<td>{wallet.platformName}</td>
															<td className="text-muted small">
																{item.address}
															</td>
															<td className="text-center">
																<div className="d-flex gap-2">
																	<Button
																		size="sm"
																		variant="outline-primary"
																		type="button"
																		onClick={() => {
																			getWolletInfo(wallet.id, item.merchantId);
																		}}>
																		Open →
																	</Button>
																	{wallet.walletInfo && (
																		<Button
																			size="sm"
																			type="button"
																			variant="outline-secondary"
																			onClick={() => {
																				showInfo(wallet.id, item.merchantId);
																			}}>
																			{wallet.walletInfo &&
																			wallet.walletInfo?.show ? (
																				<FaArrowCircleUp />
																			) : (
																				<FaArrowCircleDown />
																			)}
																		</Button>
																	)}
																</div>
															</td>
														</tr>
														{wallet.walletInfo && wallet.walletInfo?.show && (
															<tr>
																<td colSpan="4" className="p-3">
																	<div>
																		<Row className="mb-3">
																			<Col>
																				<div className="fw-bold">
																					Wallet address
																				</div>
																				<div className="text-muted small text-break">
																					{item.walletInfo?.address}
																				</div>
																			</Col>
																		</Row>

																		{wallet.walletInfo?.chains?.map(
																			(coinData, index) => (
																				<div
																					key={index}
																					className="mb-3 p-3 border rounded">
																					<div className="d-flex justify-content-between align-items-center mb-2">
																						<div className="d-flex align-items-center gap-2">
																							<img
																								src={coinData.chainLogo}
																								width={32}
																								alt="logo"
																							/>
																							<div>
																								<div className="fw-bold">
																									{coinData.chainSlug}
																								</div>
																								<div className="text-muted small">
																									{coinData.chainName}
																								</div>
																							</div>
																						</div>

																						<div className="text-end">
																							<div className="fw-bold">
																								{coinData.chainBalance}
																							</div>
																							<div className="text-muted small d-flex align-items-center justify-content-end gap-1">
																								<img
																									src={coinData.chainLogo}
																									width={14}
																									alt="logo"
																								/>
																								{coinData.currencySlug}
																							</div>
																						</div>
																					</div>

																					{coinData.contracts?.length > 0 && (
																						<div className="table-responsive">
																							<table className="table table-sm table-hover mb-0">
																								<thead className="table-light">
																									<tr>
																										<th>Token</th>
																										<th>Balance</th>
																										<th>Contract</th>
																									</tr>
																								</thead>
																								<tbody>
																									{coinData.contracts.map(
																										(contract, i) => (
																											<tr key={i}>
																												<td className="d-flex align-items-center gap-2">
																													<img
																														src={contract.logo}
																														width={18}
																														alt="logo"
																													/>
																													<b>{contract.slug}</b>
																													<span className="text-muted small">
																														({contract.name})
																													</span>
																												</td>
																												<td>
																													<b>
																														{
																															contract.contractBalance
																														}
																													</b>
																												</td>
																												<td className="text-muted small text-break">
																													{
																														contract.contractAddress
																													}
																												</td>
																											</tr>
																										),
																									)}
																								</tbody>
																							</table>
																						</div>
																					)}
																				</div>
																			),
																		)}
																	</div>
																	<div className="d-flex justify-content-end">
																		<button
																			className="btn btn-secondary"
																			type="button"
																			onClick={() => {
																				showInfo(wallet.id, item.merchantId);
																			}}>
																			Close
																		</button>
																	</div>
																</td>
															</tr>
														)}
													</React.Fragment>
												);
											})}
										</tbody>
									</Table>
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					))}
				<Pagination className="mt-3 mb-1 justify-content-end coustem_pagination align-self-stretch">
					<Pagination.First
						onClick={() => handlePageChange(1)}
						disabled={paginationData.pageNumber === 1}
					/>
					<Pagination.Prev
						onClick={() => handlePageChange(paginationData.pageNumber - 1)}
						disabled={paginationData.pageNumber === 1}
					/>
					<Pagination.Item className="coustem_pagination_item" active>
						{paginationData.pageNumber}
					</Pagination.Item>

					<Pagination.Next
						onClick={() => handlePageChange(paginationData.pageNumber + 1)}
						disabled={pagination?.totalPages === paginationData.pageNumber}
					/>
				</Pagination>
			</Container>
		</div>
	);
}

const loader = async () => {
	try {
		return [];
	} catch (error) {
		AlertService.alert("error", error);
		return error;
	}
};

const MerchantWallets = Object.assign(Component, { loader });

export default MerchantWallets;
